import { action, observable } from 'mobx'
import { createContext } from 'react'

import { BaseStore } from './BaseStore'

const INITIAL_STATE = {
  canExit: true,
  course: null,
  courseContent: null,
  quizQuestion: null,
}

const TYPES = {
  canExit: observable,
  // These should not be persisted, but our setup doesn't support ignoring. If a
  // user closes a window while in a course, and later reports feedback while
  // not on a course, the old state may be reported.
  course: observable,
  courseContent: observable,
  quizQuestion: observable,
}

export class CourseStore extends BaseStore {
  setCanExit = action((value) => {
    this.canExit = value
  })

  setCourse = action((value) => {
    this.course = value
  })

  setCourseContent = action((value) => {
    this.courseContent = value
  })

  setQuizQuestion = action((value) => {
    this.quizQuestion = value
  })
}

export const course = new CourseStore(INITIAL_STATE, TYPES)
export const CourseStoreContext = createContext(course)
